var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-5"},[_c('h1',[_vm._v(" 404 ")]),_c('h2',[_vm._v(" "+_vm._s(_vm.$t("Página no encontrada"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }